import { FC } from 'react'

import { ISvgClass } from '../interface'

const ReportIcon: FC<ISvgClass> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="24"
      height="24"
      x="0"
      y="0"
      viewBox="0 0 64 64"
      {...props}
    >
      <g>
        <path
          d="m61.71 13.29-11-11A1.033 1.033 0 0 0 50 2H25a3.009 3.009 0 0 0-3 3v6.05a20.973 20.973 0 0 0 0 41.9V59a3.009 3.009 0 0 0 3 3h34a3.009 3.009 0 0 0 3-3V14a1.033 1.033 0 0 0-.29-.71zM51 5.41 58.59 13H52a1 1 0 0 1-1-1zM4 32a19.023 19.023 0 0 1 18-18.97v18.56L8.9 44.69A18.879 18.879 0 0 1 4 32zm6.31 14.1L23.41 33h18.56a18.963 18.963 0 0 1-31.66 13.1zM60 59a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-6.05A21.014 21.014 0 0 0 44 32a1 1 0 0 0-1-1H24V5a1 1 0 0 1 1-1h24v8a3.009 3.009 0 0 0 3 3h8z"
          fill="#000000"
          opacity="1"
          data-original="#000000"
        />
        <path
          d="M27 7a1 1 0 0 0-1 1v20a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1A21.023 21.023 0 0 0 27 7zm1 20V9.03A19.017 19.017 0 0 1 45.97 27zM49 40a9 9 0 1 0 9 9 9.014 9.014 0 0 0-9-9zm0 16a7 7 0 1 1 7-7 7.008 7.008 0 0 1-7 7z"
          fill="#000000"
          opacity="1"
          data-original="#000000"
        />
        <path
          d="m47 50.586-2.293-2.293-1.414 1.414 3 3a1 1 0 0 0 1.414 0l6-6-1.414-1.414zM50 19h8v2h-8zM50 25h8v2h-8zM50 31h8v2h-8z"
          fill="#000000"
          opacity="1"
          data-original="#000000"
        />
      </g>
    </svg>
  )
}

export default ReportIcon
